import React, { useCallback, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import ButtonBase from "@material-ui/core/ButtonBase";
import Paper from "@material-ui/core/Paper";
import "video-react/dist/video-react.css";
import { Player } from "video-react";
import { Container } from "@material-ui/core";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
    float: "right",
    marginTop: "5px",
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  header: {
    fontSize: "18pt",
    fontWeight: "bold",
  },
  label: {
    fontSize: "15px",
    color: "#ad6767",
  },
  detail: {
    fontSize: "15px",
    margin: "20px 0",
  },
  role: {
    fontSize: "16px",
    margin: "20px 0",
    color: "#adadad",
  },
  tech: {
    fontSize: "15px",
    color: "#adadad",
    margin: "30px 0",
  },
}));

const Portfolio = ({ works }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [work, setWork] = useState({});
  const [viewImage, showImage] = useState(false);

  const onSelectItem = useCallback((work) => {
    setWork(work);
    setOpen(true);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const _works = works.map((work) => {
    const { category, name, imgSrc, detail, technologies, url } = work;
    return (
      <div
        className={`col-lg-4 col-md-6 video ${category} mb-30`}
        key={imgSrc}
        onClick={(e) => onSelectItem(work)}
      >
        <div className="item-img">
          <div className="part-img">
            <img src={imgSrc} alt="image" />
            <div className="overlay-img">
              <h4>{name}</h4>
              <h6>{technologies}</h6>
            </div>
          </div>
        </div>
      </div>
    );
  });

  return (
    <section id="portfolio" className="portfolio section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title-2">
              <div className="line"></div>
              <div className="text">
                <p>My Recent Work</p>
                <h3>My Work</h3>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="filtering mb-50">
              <button type="button" data-filter="*" className="active">
                All
              </button>
              <button type="button" data-filter=".react">
                React.js
              </button>
              <button type="button" data-filter=".angular">
                Angular
              </button>
              <button type="button" data-filter=".vue">
                Vue.js
              </button>
              <button type="button" data-filter=".spring">
                Spring Boot
              </button>
              <button type="button" data-filter=".node">
                Node.js
              </button>
              <button type="button" data-filter=".cms">
                CMS
              </button>
              <button type="button" data-filter=".native">
                Native App
              </button>
              <button type="button" data-filter=".hybrid">
                Hybrid App
              </button>
            </div>
          </div>
          <div className="gallery ohidden no-padding col-12">{_works}</div>
        </div>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen={true}
      >
        <DialogTitle id="alert-dialog-title">
          <IconButton
            aria-label="delete"
            className={classes.margin}
            onClick={handleClose}
          >
            <CloseIcon fontSize="large" style={{ color: "FF0000" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={7}>
              {work.videoSrc && (
                <Paper elevation={10}>
                  <Player
                    playsInline
                    poster={work.imgSrc}
                    src={work.videoSrc}
                  />
                </Paper>
              )}
              {!work.videoSrc && (
                <Paper elevation={10}>
                  <div className="item-img">
                    <div className="part-img">
                      <ButtonBase
                        onClick={() => {
                          showImage(true);
                        }}
                      >
                        <img src={work.imgSrc} alt="image" />
                      </ButtonBase>
                    </div>
                  </div>
                </Paper>
              )}
            </Grid>
            <Grid item xs={12} sm={5} container>
              <Container>
                <p className={classes.header}>{work.name}</p>
                <p className={classes.detail}>{work.detail}</p>
                <p className={classes.role}>
                  <span className={classes.label}>role:</span> {work.role}
                </p>
                <p className={classes.tech}>
                  <span className={classes.label}>technologies:</span>{" "}
                  {work.technologies}
                </p>
                {work.url && (
                  <a href={work.url} target="_blank">
                    Click here to link
                  </a>
                )}
              </Container>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <div style={{ display: viewImage ? "block" : "none" }}>
        <Lightbox
          onClose={() => {
            showImage(false);
          }}
          image={work.imgSrc}
        ></Lightbox>
      </div>
    </section>
  );
};

export default Portfolio;
